import Input from "@mui/material/Input";
import React, { useState } from "react";
import { GetPurchaseOrderListResponseArray } from "../../../@types/DRO/PurchaseOrderResponse";
import { DownloadPdfApi } from "../../../api/PdfDownload/DownloadPdfApi";
import DeliveryOrderHistoryModal from "../../UI/DeliveryOrder/DeliveryOrderHistory";

const ariaLabel = { "aria-label": "description" };

interface UserFormTableComponentProps {
  orderDetails: GetPurchaseOrderListResponseArray;
}

const UserFormTableComponent: React.FC<UserFormTableComponentProps> = ({
  orderDetails,
}) => {
  const [showDOHistory, setShowDOHistory] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false); 

  const handleDOHistoryClick = () => {
    setShowDOHistory(true);
  };

  const handleDownloadPdf = async () => {
    try {
      setIsDownloading(true);
      await DownloadPdfApi.api.getPdfLinkByPOId(orderDetails.id);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      alert("Failed to download PDF. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      <div className="p-5 bg-white border rounded-lg shadow-sm">
        <div className="flex justify-between">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-500 text-sm font-inter">
            <div className="m-2">
              <p className="text-start font-semibold">Vendor ID</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.vendorDetails?.vendorId || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
            <div className="m-2">
              <p className="font-semibold text-start">Vendor Name</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.vendorDetails?.vendorName || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
            <div className="m-2">
              <p className="font-semibold text-start">GST Treatment</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.gstTreatment || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
            <div className="m-2">
              <p className="font-semibold text-start">Expected Arrival</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.expectedArrival || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
            <div className="m-2">
              <p className="font-semibold text-start">Confirmation Date</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.confirmationDate || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
            <div className="m-2">
              <p className="font-semibold text-start">Amount</p>
              <Input
                className="w-full"
                defaultValue={orderDetails.amount || "N/A"}
                inputProps={ariaLabel}
                disabled
              />
            </div>
          </div>
          <div className="mt-4 flex flex-col gap-2 m-4">
            <button
              onClick={handleDownloadPdf}
              disabled={isDownloading}
              className={`flex items-center justify-center px-4 py-2 text-sm bg-[#1366D9] text-white rounded-md hover:bg-blue-800 font-semibold transition-all duration-150 shadow-md hover:shadow-lg whitespace-nowrap ${
                isDownloading ? "opacity-50 cursor-not-allowed" : ""
              }`}>
              {isDownloading ? "Downloading..." : "Download"}
            </button>

           {orderDetails.status.name === "APPROVED" && (
             <a
               href={`/delivery-order/${orderDetails.id}`}
               className="flex items-center justify-center px-4 py-2 text-sm bg-[#1366D9] text-white rounded-md hover:bg-blue-800 font-semibold transition-all duration-150 shadow-md hover:shadow-lg whitespace-nowrap">
               Create DO
             </a>
           )}
            <button
              onClick={handleDOHistoryClick}
              className="flex items-center justify-center px-4 py-2 text-sm bg-[#1366D9] text-white rounded-md hover:bg-blue-800 font-semibold transition-all duration-150 shadow-md hover:shadow-lg whitespace-nowrap">
              DOs History
            </button>
          </div>
        </div>
      </div>

      <DeliveryOrderHistoryModal
        isOpen={showDOHistory}
        onClose={() => setShowDOHistory(false)}
        purchaseOrderId={orderDetails.id}
      />
    </>
  );
};

export default UserFormTableComponent;
